import { FC, ReactNode } from 'react';
import { Root } from './styled';

type Props = {
  children?: ReactNode;
  size?: string;
  marginLeft?: string;
};

const CardContainer: FC<Props> = ({ children, size, marginLeft }) => {
  return (
    <Root size={size} marginLeft={marginLeft}>
      {children}
    </Root>
  );
};

export default CardContainer;
